import { useGetCashbackSummaryQuery } from "../../../../services/transactions/transactionsApi";
import { UseSavingCashbackOptions, UseSavingCashbackReturn } from "./types";

export const useSavingCashback = (
  accountId: number,
  { skip = false }: UseSavingCashbackOptions = {},
): UseSavingCashbackReturn => {
  const {
    currentData: summary,
    isError,
    refetch,
  } = useGetCashbackSummaryQuery(accountId, { skip });

  return {
    summary,
    isError,
    retry: () => {
      void refetch();
    },
  };
};
